/**
 * Wire bootstrap — wires the singleton store to a singleton socket and exposes
 * a singleton `actions` to components. Test code never imports this module;
 * tests construct their own `Store`/`HookumSocket`/`Actions` triple.
 */
import { HookumSocket } from "../net/socket.js";
import { store } from "../state/store.js";
import { createActions, type Actions } from "./actions.js";

export const socket = new HookumSocket(store);
export const actions: Actions = createActions(socket, store);
